<router-outlet></router-outlet>

<!--app toast-->
<app-toast></app-toast>

<!-- confirm dialog -->
<p-confirmDialog #cd key="dialog" class="confirm-dialog">
  <ng-template pTemplate="headless" let-data>
    <div class="confirmation-body">
      <p class="confirmation-message" [innerHTML]="data.message"></p>
      <div class="confirmation-buttons">
        <p-button [label]="'button.no' | translate" severity="secondary" (click)="cd.onReject()"/>
        <p-button [label]="'button.yes' | translate" severity="contrast" (click)="cd.onAccept()"/>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<!-- spinner -->
<div class="global-spinner p-overlay-mask" [class.visible]="spinner | async">
  <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
</div>